<template>
  <div class="shed-container">
    <div v-show="isHidden" ref="header" class="shed-header">
      <div class="shed-header-left">
        <div class="title">
          <img src="./img/icon.png" />
          <span>区域参数</span>
        </div>
        <div class="content">
          <div class="content-item">
            <span class="label">厂区名称:</span>
            <span class="value">{{
              shedBasic.shedName ? shedBasic.shedName : "--"
            }}</span>
          </div>
          <div class="content-item">
            <span class="label">高度:</span>
            <span class="value">{{ areaHeight ? areaHeight : "--" }}</span>
          </div>
          <div class="content-item">
            <span class="label">堆料种类:</span>
            <span class="value">{{
              shedBasic.material ? shedBasic.material : "干料"
            }}</span>
          </div>
          <div class="content-item">
            <span class="label">分区:</span>
            <span class="value">{{
              "x" + shedList.filter((item) => item.type === 6).length
            }}</span>
          </div>
          <div class="content-item">
            <span class="label">料棚面积:</span>
            <span class="value">{{ areaSize ? areaSize : "--" }}</span>
          </div>
          <div class="content-item">
            <span class="label">进出口:</span>
            <span class="value">x10</span>
            <!-- <span class="value">{{ areaDoors ? areaDoors : "--" }}</span> -->
          </div>
          <div class="content-item">
            <span class="label">堆料方式:</span>
            <span class="value">--</span>
          </div>
        </div>
      </div>
      <div class="shed-header-right">
        <div class="illus-bar">
          <ul class="ui-choose" multiple="multiple" id="uc_03">
            <li
              @click="
                ($event) => {
                  initIllus_($event, 2);
                }
              "
              class="wupao selected"
            >
              雾炮<span class="number">{{ fogDevice.length }}</span>
              <div class="imgIcon">
                <img class="ui-icon" src="./img/foggun.png" />
              </div>
              <span class="unit">台</span>
            </li>
            <li
              @click="
                ($event) => {
                  initIllus_($event, 3);
                }
              "
              class="vdm150 selected"
            >
              vdm<span class="number">{{
                vdm150Device.length + vdmDevice.length
              }}</span>
              <div class="imgIcon">
                <img class="ui-icon" src="./img/VDM.png" />
              </div>
              <span class="unit">台</span>
            </li>
            <li
              @click="
                ($event) => {
                  initIllus_($event, 5);
                }
              "
              class="selected"
            >
              全景相机<span class="number">2</span>
              <div class="imgIcon">
                <img class="ui-icon" src="./img/yingyan.png" />
              </div>
              <span class="unit">台</span>
            </li>
            <li
              @click="
                ($event) => {
                  initIllus_($event, 6);
                }
              "
              class="selected"
            >
              洗车机<span class="number">{{ washCarDevice.length }}</span>
              <div class="imgIcon">
                <img
                  style="transform: scale(0.5); margin-top: 0"
                  class="ui-icon"
                  src="./img/washcar.png"
                />
              </div>
              <span class="unit">台</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="shed-btn">
      <el-button @click="btnClick">{{ getText }}</el-button>
    </div>
    <div ref="body" class="shed-body blockHeight">
      <div class="shed-body-left">
        <div class="shed-map-left" @click="clickDebounce">
          <!-- 弹窗 -->
          <div class="toolTip scaleItem" ref="toolTip">
            <div class="toolTip-header">区域【{{ curHoverDeviceNo }}】</div>
            <div class="toolTip-body">
              <div class="toolTip-item">
                <span>面积:</span>
                <span>{{ curLen * curWidth + "米²" }}</span>
              </div>
              <div class="toolTip-item">
                <span>尺寸:</span>
                <span>{{
                  "长：" +
                  (curLen ? curLen : 0) +
                  "米； 宽：" +
                  (curWidth ? curWidth : 0) +
                  "米"
                }}</span>
              </div>
              <div class="toolTip-item">
                <span>设备:</span>
                <span>{{
                  (region?._deviceAliasName ||
                    region?.deviceAliasName ||
                    region?._deviceNo ||
                    region?.deviceNo) + "在线"
                }}</span>
              </div>
            </div>
          </div>
          <!-- 顶部 -->
          <div class="scaleItem">
            <template
              v-for="(item, i) in vdm150Area"
              v-bind:key="item.deviceNo"
            >
              <div
                :id="item.deviceNo"
                :class="{
                  bb: true,
                }"
                :style="getRegionStyle(item, i)"
                @mouseleave="mouseleaveHandle"
                @mousemove="mouseoverHandle(item)"
              >
                <img
                  :data-index="'top' + i"
                  style="position: relative; z-index: 1"
                  :src="item.base64"
                  alt=""
                />
              </div>
            </template>
          </div>
          <!-- 电子围栏 / vdm 1+2 -->
          <div class="scaleItem">
            <template v-for="(item, i) in vdmDevice" v-bind:key="item.deviceNo">
              <div
                :id="item.deviceNo"
                :class="{
                  bb: true,
                }"
                data
                :style="getRegionStyle(item, i)"
                style="z-index: 9999999"
                @mouseleave="mouseleaveHandle"
                @mousemove="mouseoverHandle(item)"
              >
                <img :data-index="'vdm' + i" :src="item.base64" alt="" />
                <div
                  :data-index="'click' + i"
                  :style="getfogDStyle(item, i)"
                  class="realTime"
                >
                  <count-to
                    class="number"
                    :startVal="0"
                    :endVal="item._realTimeValue"
                    :duration="2000"
                  ></count-to>
                </div>
              </div>
            </template>
          </div>
          <!-- 雾炮设备 -->
          <div v-if="fogShow" class="scaleItem">
            <template v-for="(item, i) in fogDevice" v-bind:key="item.deviceNo">
              <div
                :id="item.deviceNo"
                :class="{
                  bb: true,
                }"
                :style="getRegionStyle(item, i)"
                style="z-index: 999"
              >
                <img :data-index="'imgFog' + i" :src="item.base64" alt="" />
              </div>
            </template>
          </div>
          <!-- vdm150 -->
          <div v-if="vdmShow" class="scaleItem">
            <template
              v-for="(item, i) in vdm150Device"
              v-bind:key="item.deviceNo"
            >
              <div
                :id="item.deviceNo"
                :class="{
                  bb: true,
                }"
                :style="getRegionStyle(item, i)"
              >
                <img :data-index="'top' + i" :src="item.base64" alt="" />
              </div>
            </template>
          </div>
          <!-- 全景相机 -->
          <div v-if="eagleShow" class="scaleItem">
            <template
              v-for="(item, i) in videoDevice"
              v-bind:key="item.deviceNo"
            >
              <div
                :id="item.deviceNo"
                :class="{
                  bb: true,
                }"
                :style="getRegionStyle(item, i)"
              >
                <img :src="item.base64" alt="" />
              </div>
            </template>
          </div>
          <!-- 洗车机 -->
          <div v-if="washShow" class="scaleItem">
            <template
              v-for="(item, i) in washCarDevice"
              v-bind:key="item.deviceNo"
            >
              <div
                :id="item.deviceNo"
                :class="{
                  bb: true,
                }"
                :style="getRegionStyle(item, i)"
                style="z-index: 999"
              >
                <img :data-index="'wash' + i" :src="item.base64" alt="" />
              </div>
            </template>
          </div>
        </div>
        <div v-if="detailShow" class="shed-body-detail">
          <vdmDetail :detailPopup="detailPopup" />
        </div>
      </div>
      <div class="shed-body-right">
        <div class="shed-map-right" @click="clickDebounce">
          <!-- 弹窗 -->
          <div class="toolTip scaleItem" ref="toolTipRight">
            <div class="toolTip-header">区域【{{ curHoverDeviceNo }}】</div>
            <div class="toolTip-body">
              <div class="toolTip-item">
                <span>面积:</span>
                <span>{{ curLen * curWidth + "米²" }}</span>
              </div>
              <div class="toolTip-item">
                <span>尺寸:</span>
                <span>{{
                  "长：" +
                  (curLen ? curLen : 0) +
                  "米； 宽：" +
                  (curWidth ? curWidth : 0) +
                  "米"
                }}</span>
              </div>
              <div class="toolTip-item">
                <span>设备:</span>
                <span>{{
                  (region?._deviceAliasName || region?._deviceNo) + "在线"
                }}</span>
              </div>
            </div>
          </div>
          <!-- 雾炮区域 -->
          <div class="scaleItem">
            <template v-for="(item, i) in fogArea" v-bind:key="item.deviceNo">
              <div
                :id="item.deviceNo"
                :class="{
                  bb: true,
                }"
                :style="getRegionStyle(item, i)"
                @mouseleave="mouseleaveHandle"
                @mousemove="mouseoverHandle(item)"
              >
                <img
                  :data-index="'imgFog' + i"
                  :src="item.base64"
                  style="position: absolute; top: 0; left: 0; z-index: 999"
                  alt=""
                />
              </div>
            </template>
          </div>
          <!-- 雾炮设备 -->
          <div v-if="fogShow" class="scaleItem">
            <template v-for="(item, i) in fogDevice" v-bind:key="item.deviceNo">
              <div
                :id="item.deviceNo"
                :class="{
                  bb: true,
                }"
                :style="getRegionStyle(item, i)"
                style="z-index: 999"
              >
                <img :data-index="'imgFog' + i" :src="item.base64" alt="" />
              </div>
            </template>
          </div>
          <!-- vdm150 -->
          <div v-if="vdmShow" class="scaleItem">
            <template
              v-for="(item, i) in vdm150Device"
              v-bind:key="item.deviceNo"
            >
              <div
                :id="item.deviceNo"
                :class="{
                  bb: true,
                }"
                :style="getRegionStyle(item, i)"
              >
                <img :data-index="'top' + i" :src="item.base64" alt="" />
              </div>
            </template>
          </div>
          <!-- 全景相机 -->
          <div v-if="eagleShow" class="scaleItem">
            <template
              v-for="(item, i) in videoDevice"
              v-bind:key="item.deviceNo"
            >
              <div
                :id="item.deviceNo"
                :class="{
                  bb: true,
                }"
                :style="getRegionStyle(item, i)"
              >
                <img :src="item.base64" alt="" />
              </div>
            </template>
          </div>
          <!-- 洗车机 -->
          <div v-if="washShow" class="scaleItem">
            <template
              v-for="(item, i) in washCarDevice"
              v-bind:key="item.deviceNo"
            >
              <div
                :id="item.deviceNo"
                :class="{
                  bb: true,
                }"
                :style="getRegionStyle(item, i)"
                style="z-index: 999"
              >
                <img :data-index="'wash' + i" :src="item.base64" alt="" />
              </div>
            </template>
          </div>
        </div>
        <div v-if="fogDetailShow || washDetaiShow" class="shed-right-detail">
          <foggun-bar v-if="fogDetailShow" :fogDetail="fogDetail" />
          <wash-bar v-if="washDetaiShow" :washDetail="washDetail" />
        </div>
      </div>
    </div>
    <div class="shed-close" @click="returnFunc()">
      <!-- <span>X</span> -->
    </div>

    <!-- <div class="shed-map-right"></div> -->
  </div>
</template>

<script>
// 防抖
let timer = null;
function debounce(callback, delay, that) {
  return function () {
    const argu = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      callback.apply(that, argu);
    }, delay);
  };
}
// 电子围栏区域映射
let reflectObj = {
  "39_004_014": "39_004_014",
  "39_004_015": "39_004_015",
  "39_004_016": "39_004_016",
  "39_004_017": "39_004_017",
  "39_004_018": "39_004_018",
  "39_004_030": "39_004_019",
  "39_004_019": "39_004_020",
  "39_004_020": "39_004_021",
  "39_004_021": "39_004_022",
  "39_004_022": "39_004_023",
  "39_004_031": "39_004_024",
  "39_004_023": "39_004_025",
  "39_004_024": "39_004_026",
  "39_004_025": "39_004_027",
  "39_004_026": "39_004_028",
  "39_004_027": "39_004_029",
  "39_004_028": "39_004_030",
  "39_004_029": "39_004_031",
};
// 雾炮区域映射
let reflectFogObj = {
  "39_004_001": "39_004_010",
  "39_004_002": "39_004_009",
  "39_004_003": "39_004_008",
  "39_004_004": "39_004_007",
  "39_004_005": "39_004_006",
  "39_004_006": "39_004_001",
  "39_004_007": "39_004_002",
  "39_004_008": "39_004_003",
  "39_004_009": "39_004_004",
  "39_004_010": "39_004_005",
};
import countTo from "@/components/VueCountTo/vue-countTo.vue";
import { unref, computed, nextTick } from "vue";
import foggunBar from "./compenont/foggunBar.vue";
import washBar from "./compenont/washBar.vue";
import vdmDetail from "@/modules/unorganizedComponents/vdmBar/vdmDevice/vdmDetail.vue";
export default {
  name: "NewShedForth",
  components: {
    vdmDetail,
    foggunBar,
    washBar,
    countTo,
  },
  inject: {
    updateAllEmissionVdmId: {
      from: "updateAllEmissionVdmId",
      default: () => "",
    },
    getAllEmissionVdmId: {
      from: "getAllEmissionVdmId",
      default: () => "",
    },
    getDeviceTabs: {
      from: "getDeviceTabs",
      default: () => "",
    },
    getVdmArea: {
      from: "getVdmArea",
      default: () => "",
    },
    updateVdmArea: {
      from: "updateVdmArea",
      default: () => "",
    },

    updateLeftRightPart: {
      from: "updateLeftRightPart",
      default: () => "",
    },
    updateSourceShow: {
      from: "updateSourceShow",
      default: () => "",
    },
    updateEmissionLoading: {
      from: "updateEmissionLoading",
      default: () => "",
    },
  },
  computed: {
    getRegionStyle() {
      return function (item, i) {
        let zIndex = 1;
        // left 867 - 677  top - 300
        return {
          position: "absolute",
          left: parseInt(item.leftAddress) + "px",
          top: parseInt(item.topAddress) + "px",
          width: parseInt(item.regionLength) + "px",
          height: parseInt(item.regionWith) + "px",
          transformOrigin: "center center",
          zIndex,
        };
      };
    },
    getfogDStyle() {
      return function (item, i) {
        switch (i) {
          case 6:
            return {
              transform: "rotate(58deg)",
              margin: "0 5px 0 0",
            };
          case 7:
          case 13:
          case 14:
          case 15:
            return {
              writingMode: "vertical-lr",
            };
        }
      };
    },
    getTipStyle() {
      return function (currItem) {
        const { item, index } = currItem;
        if (item.deviceName.indexOf("4#料棚雾炮区域") !== -1) {
          return {
            position: "absolute",
          };
        } else if (item.type === 5) {
        }
      };
    },
    getText() {
      if (this.isHidden) {
        return "隐藏";
      } else {
        return "展开";
      }
    },
  },
  watch: {
    getVdmArea: {
      handler(newVal, oldVal) {
        this.materialObj = unref(newVal);
        if (this.materialObj) {
          let that = this;
          that.signalList = [];
          this.shedId = this.materialObj.shedNo;
          this.shedName = this.materialObj.shedName;
          this.getShedInfo();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      areaSize: "",
      areaHeight: "",
      areaDoors: " x 2",
      curHoverDeviceNo: "",
      region: "",
      timer1: null,
      setTimer: null,
      delay: 500,
      isHidden: true,
      loading: false,
      isLeft: false,
      fogShow: true,
      vdmShow: true,
      eagleShow: true,
      washShow: true,
      detailShow: false,
      fogDetailShow: false,
      washDetaiShow: false,
      shedBasic: {},
      materialObj: {},
      detailPopup: {},
      vdmMap: {},
      fogMap: {},
      regionMap: {
        "39_004_014": 1652, // 1 1652
        "39_004_015": 1653, // 2 1653
        "39_004_016": 1654, // 3 1654
        "39_004_017": 1655, // 4
        "39_004_018": 1656, // 5
        "39_004_019": 1657, // 6
        "39_004_020": 1658, // 7
        "39_004_021": 1659, // 8
        "39_004_022": 1660, // 9
        "39_004_023": 1661, // 10
        "39_004_024": 1662, // 11
        "39_004_025": 1663, // 12
        "39_004_026": 1664, // 13
        "39_004_027": 1665, // 14
        "39_004_028": 1666, // 15 1666  67
        "39_004_029": 1667, // 16 1667  133
        "39_004_030": 1656, // 17
        "39_004_031": 1661, // 18
      }, // 区域与图片映射
      fogDetail: {},
      washDetail: {},
      shedList: [],
      fogDevice: [],
      fogArea: [],
      vdm150Device: [],
      vdm150Area: [],
      videoDevice: [],
      washCarDevice: [],
      vdmDevice: [],
      vdmArea: [],
    };
  },
  methods: {
    // 获取料棚基本信息
    async getShedInfo() {
      if (this.setTimer) {
        clearTimeout(this.setTimer);
        this.setTimer = null;
      }
      let url = CONFIG.requestName + this.$apiOpt.detailNew;
      // let url = "http://screen.bmetech.com/screen" + this.$apiOpt.detailNew;
      try {
        let res = await this.$apiUtils.get(url, {
          customerId: this.$store.state.customerId,
          // customerId: "39",
          // shedNo: this.materialObj.shedNo,
          shedNo: "39_004",
        });
        this.shedBasic = res.basic;
        this.shedList = res.layout;
        this.areaSize =
          res.basic.area +
          "米² (" +
          res.basic.leng +
          "米 x " +
          res.basic.width +
          "米)";
        this.disposeDevice(this.shedList);
        this.setTimer = setTimeout(() => this.getShedInfo(), 1000 * 60 * 10);
      } catch (err) {
        this.loading = false;
        console.error(err);
      }
    },
    // 处理各分区与设备
    disposeDevice(list) {
      this.fogDevice = [];
      this.vdm150Device = [];
      this.vdmDevice = [];
      this.washCarDevice = [];
      this.videoDevice = [];
      this.vdm150Area = [];
      this.fogArea = [];
      let tmpVDMList = list.filter((item) => item.type === 7);
      let tmpWPDeviceList = list.filter((item) => item.type === 2);
      let tmpWPList = list.filter(
        (item) =>
          item.type === 6 && item.deviceName.indexOf("4#料棚雾炮区域") !== -1
      );
      let tmpVDMArenaList = list.filter(
        (item) =>
          item.type === 6 && item.deviceName.indexOf("4#料棚围栏区域") !== -1
      );
      tmpWPList.forEach((item) => {
        let changeItem = tmpWPList.find(
          (groupItem) => groupItem.deviceNo === reflectFogObj[item.deviceNo]
        );
        let changeDeviceItem = tmpWPDeviceList.find(
          (groupItem) => groupItem.regions === reflectFogObj[item.deviceNo]
        );
        if (changeItem && changeDeviceItem) {
          item._deviceName = changeItem.deviceName;
          item._deviceNo = changeDeviceItem.deviceNo;
          item._status = changeItem.status;
          this.fogArea.push(this.renderImg(item, item.deviceNo));
        }
      });
      tmpWPDeviceList.forEach((item) => {
        let changeItem = tmpWPDeviceList.find(
          (groupItem) => groupItem.regions === reflectFogObj[item.regions]
        );
        if (changeItem) {
          item._deviceNo = changeItem.deviceNo;
          item._regions = changeItem.regions;
          item._signalNo = changeItem.signalNo;
          item._deviceAliasName = changeItem.deviceAliasName;
          this.fogDevice.push(this.renderImg(item, "wupao"));
        }
      });
      tmpVDMList.forEach((item) => {
        // 找出对应的变更区域
        let changeItem = tmpVDMList.find(
          (groupItem) => groupItem.regions === reflectObj[item.regions]
        );
        let arenaItem = tmpVDMArenaList.find(
          (arenaItem) => arenaItem.deviceNo === reflectObj[item.regions]
        );
        if (changeItem) {
          item._realTimeValue = changeItem.realTimeValue;
          item._deviceNo = changeItem.deviceNo;
          item._regions = changeItem.regions;
          item._signalNo = changeItem.signalNo;
          item._status = changeItem.status;
          item._deviceAliasName = changeItem.deviceAliasName;
          item._deviceName = arenaItem.deviceName;
          let tmp = "";
          if (!item.regions) {
            tmp = item.id;
          } else {
            tmp = this.regionMap[item.regions];
          }
          this.vdmDevice.push(this.renderImg(item, tmp));
        }
      });

      list.forEach((item) => {
        switch (item.type) {
          // case 2: // 雾炮设备
          //   this.fogDevice.push(this.renderImg(item, "wupao"));
          //   break;
          case 5: // vdm150设备
            this.vdm150Device.push(this.renderImg(item, "vdm150"));
            break;
          // case 7: // vdm 1 + 2
          //   let tmp = "";
          //   if (!item.regions) {
          //     tmp = item.id;
          //   } else {
          //     tmp = this.regionMap[item.regions];
          //   }
          //   this.vdmDevice.push(this.renderImg(item, tmp));
          //   break;
          case 3: // 洗车机
            this.washCarDevice.push(this.renderImg(item, "xicheji"));
            break;
          case 4: // 全景相机
            this.videoDevice.push(this.renderImg(item, "caremaquanjing"));
            break;
          case 6: // 区域
            if (item.deviceName.indexOf("4#料棚雾顶部") !== -1) {
              this.vdm150Area.push(this.renderImg(item, item.deviceNo));
            } else if (item.deviceName.indexOf("4#料棚雾炮区域") !== -1) {
              // this.fogArea.push(this.renderImg(item, item.deviceNo));
              this.fogMap[item.deviceNo] = item;
            } else if (item.deviceName.indexOf("4#料棚围栏区域") !== -1) {
              this.vdmMap[item.deviceNo] = item;
            }
            break;
        }
      });
      this.vdmDevice.forEach((item) => {
        if (this.vdmMap[item.regions]) {
          item.width = this.vdmMap[item.regions]["regionWith"];
          item.length = this.vdmMap[item.regions]["regionLength"];
          item.deviceName = this.vdmMap[item.regions]["deviceName"];
        }
      });
      this.fogArea.forEach((item) => {
        if (this.fogArea[item.regions]) {
          item.width = this.vdmMap[item.regions]["regionWith"];
          item.length = this.vdmMap[item.regions]["regionLength"];
          item.deviceName = this.vdmMap[item.regions]["deviceName"];
        }
      });
    },
    // 加载图片
    renderImg(item, prop) {
      var img = new Image();
      let status = item._status || item.status;
      if (status !== 1) {
        img.src = require("@/modules/unorganizedComponents/newShed/img/" +
          prop +
          ".png");
      } else {
        img.src = require("@/modules/unorganizedComponents/newShed/img/" +
          prop +
          "_c" +
          ".png");
      }
      if (img.src) {
        img.onload = function () {
          item.base64 = img.src;
        };
      }
      return item;
    },
    // 返回
    returnFunc() {
      console.log("return");
      // this.shedId = false;
      this.$router.push({
        path: `/MainMod?customerId=${bmeConfig.customerSign}`,
        hash: "",
      });
      window.bmeConfig.isShowForthShed = false;
      this.$store.commit("updateShowShed", false);
    },
    // banner按钮
    initIllus_(event, index) {
      if ($(event.currentTarget).hasClass("selected")) {
        if (index === 0) {
          let regionsShow = false;
          this.regionsShow = regionsShow;
          $(".bb").hide();
        } else if (index === 1) {
          let regionsValShow = false;
          this.regionsValShow = regionsValShow;
          $(".t_mbox").hide();
        } else if (index === 3) {
          let vdmShow = false;
          this.vdmShow = vdmShow;
          $(".vdmEquip").hide();
        } else if (index === 4) {
          let tspShow = false;
          this.tspShow = tspShow;
          $(".tspEquip").hide();
        } else if (index === 6) {
          let washShow = false;
          this.washShow = washShow;
          $(".washEquip").hide();
        } else if (index === 5) {
          let eagleShow = false;
          this.eagleShow = eagleShow;
          $(".eagleEquip").hide();
        } else if (index === 2) {
          let fogShow = false;
          this.fogShow = fogShow;
          $(".fogEquip").hide();
        }
        $(event.currentTarget).removeClass("selected");
      } else {
        if (index === 0) {
          let regionsShow = true;
          this.regionsShow = regionsShow;
          $(".bb").show();
        } else if (index === 1) {
          let regionsValShow = true;
          this.regionsValShow = regionsValShow;
          $(".t_mbox").show();
        } else if (index === 3) {
          let vdmShow = true;
          this.vdmShow = vdmShow;
          $(".vdmEquip").show();
        } else if (index === 4) {
          let tspShow = true;
          this.tspShow = tspShow;
          $(".tspEquip").show();
        } else if (index === 6) {
          let washShow = true;
          this.washShow = washShow;
          $(".washEquip").show();
        } else if (index === 5) {
          let eagleShow = true;
          this.eagleShow = eagleShow;
          $(".eagleEquip").show();
        } else if (index === 2) {
          let fogShow = true;
          this.fogShow = fogShow;
          $(".fogEquip").show();
        }
        $(event.currentTarget).addClass("selected");
      }
    },
    // 鼠标滑动
    mouseleaveHandle() {
      $(this.$refs.toolTip).hide();
      $(this.$refs.toolTipRight).hide();
    },
    mouseoverHandle(item) {
      const x =
        event.currentTarget.offsetLeft + event.currentTarget.offsetWidth;
      const x_ = event.currentTarget.offsetLeft;
      const y = event.currentTarget.offsetTop;
      if (item.deviceName.indexOf("4#料棚雾炮区域") !== -1) {
        $(this.$refs.toolTipRight)
          .css("top", (y - 200) / 2 + "px")
          .css(
            "left",
            (x_ - 300 - $(this.$refs.toolTipRight).outerWidth()) / 2 + "px"
          );
        $(this.$refs.toolTipRight).show();
      } else {
        if (item.deviceType === "电子围栏") {
          let id = item.id;
          switch (id) {
            case 1652:
            case 2570:
              $(this.$refs.toolTip)
                .css("top", (y - 100) / 2 + "px")
                .css(
                  "left",
                  (x_ - $(this.$refs.toolTip).outerWidth()) / 2 + 150 + "px"
                );
              break;
            case 1653:
            case 1654:
            case 1655:
            case 1656:
            case 1657:
            case 2571:
            case 2572:
            case 2573:
            case 2574:
            case 2575:
              $(this.$refs.toolTip)
                .css("top", (y - 100) / 2 + "px")
                .css(
                  "left",
                  (x_ - $(this.$refs.toolTip).outerWidth()) / 2 + "px"
                );
              break;
            case 1667:
            case 2585:
              $(this.$refs.toolTip)
                .css("top", (y - 410) / 2 + 150 + "px")
                .css(
                  "left",
                  (x_ - $(this.$refs.toolTip).outerWidth()) / 2 + 180 + "px"
                );
              break;
            case 1666:
            case 1665:
            case 2584:
            case 2583:
              $(this.$refs.toolTip)
                .css("top", (y - 410) / 2 + 50 + "px")
                .css(
                  "left",
                  (x_ - $(this.$refs.toolTip).outerWidth()) / 2 + 180 + "px"
                );
              break;
            case 1658:
            case 2576:
              $(this.$refs.toolTip)
                .css("top", (y - 410) / 2 + 150 + "px")
                .css(
                  "left",
                  (x_ - $(this.$refs.toolTip).outerWidth()) / 2 - 150 + "px"
                );
              break;
            case 1659:
            case 2577:
              $(this.$refs.toolTip)
                .css("top", (y - 410) / 2 + 50 + "px")
                .css(
                  "left",
                  (x_ - $(this.$refs.toolTip).outerWidth()) / 2 - 150 + "px"
                );
              break;
            case 1664:
            case 2582:
              $(this.$refs.toolTip)
                .css("top", (y - 500) / 2 + "px")
                .css(
                  "left",
                  (x_ - $(this.$refs.toolTip).outerWidth()) / 2 + 150 + "px"
                );
              break;
            case 1663:
            case 1662:
            case 1661:
            case 1660:
            case 2578:
            case 2579:
            case 2580:
            case 2581:
              $(this.$refs.toolTip)
                .css("top", (y - 500) / 2 + "px")
                .css(
                  "left",
                  (x_ - $(this.$refs.toolTip).outerWidth()) / 2 + 50 + "px"
                );
              break;
          }
        } else {
          $(this.$refs.toolTip)
            .css("top", (y - 400) / 2 + 100 + "px")
            .css(
              "left",
              (x_ - $(this.$refs.toolTip).outerWidth()) / 2 + 130 + "px"
            );
        }

        $(this.$refs.toolTip).show();
      }
      this.curHoverDeviceNo = item._deviceName || item.deviceName;
      if (item.deviceType === "电子围栏") {
        this.region = item;
        this.curLen = item.length;
        this.curWidth = item.width;
      } else {
        this.curLen = item.regionLength;
        this.curWidth = item.regionWith;
        let arr = this.shedList.filter((s) => s.type !== 6);
        this.region = arr.find((a) => a?.regions == item?.deviceNo);
      }
    },
    // 详情弹出
    clickHandle(event) {
      if (
        (event.target.nodeName.toLowerCase() === "img" ||
          event.target.nodeName.toLowerCase() === "div") &&
        event.target.getAttribute("data-index")
      ) {
        let str = event.target.getAttribute("data-index");
        if (
          event.target.getAttribute("data-index").indexOf("vdm") !== -1 ||
          event.target.getAttribute("data-index").indexOf("click") !== -1
        ) {
          let arr = [];
          if (str.indexOf("vdm") !== -1) {
            arr = str.split("m");
          } else {
            arr = str.split("k");
          }
          let index = arr[1];
          this.detailPopup = this.vdmDevice[index];
          this.detailShow = true;
        } else if (
          event.target.getAttribute("data-index").indexOf("imgFog") !== -1
        ) {
          let arr = str.split("g");
          let index = arr[2];
          this.fogDetail = this.fogDevice[index];
          if (this.washDetaiShow) this.washDetaiShow = false;
          this.fogDetailShow = true;
        } else if (
          event.target.getAttribute("data-index").indexOf("top") !== -1
        ) {
          let arr = str.split("p");
          let index = arr[1];
          this.detailPopup = this.vdm150Device[index];
          this.detailShow = true;
        } else if (
          event.target.getAttribute("data-index").indexOf("wash") !== -1
        ) {
          let arr = str.split("h");
          let index = arr[1];
          this.washDetail = this.washCarDevice[index];
          if (this.fogDetailShow) this.fogDetailShow = false;
          this.washDetaiShow = true;
          console.log(this.washDetail);
        }
      }
    },
    clickDebounce(event) {
      debounce(this.clickHandle, this.delay, this)(event);
    },
    // 折叠头部详情
    btnClick() {
      if (this.isHidden) {
        $(".shed-header").removeClass("transDown").addClass("transUp");
        this.timer1 = setTimeout(() => {
          this.isHidden = false;
          $(".shed-body")
            .removeClass("transBodyDown blockHeight")
            .addClass("transBodyUp noneHeight");
        }, 200);
      } else {
        this.isHidden = true;
        $(".shed-body")
          .removeClass("transBodyUp noneHeight")
          .addClass("transBodyDown blockHeight");
        this.timer1 = setTimeout(() => {
          $(".shed-header").removeClass("transUp").addClass("transDown");
        });
      }
    },
  },
  mounted() {
    this.getShedInfo();
  },
  unmounted() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (this.timer1) {
      clearTimeout(this.timer1);
      this.timer1 = null;
    }
    if (this.setTimer) {
      clearTimeout(this.setTimer);
      this.setTimer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.shed {
  &-container {
    width: 3600px;
    height: 900px;
    position: absolute;
    // top: 90px;
    // left: 50%;
    // transform: translateX(-50%);
    transform: scale(1.1, 1.18);
    transform-origin: 0 0;
    z-index: 300000;
    pointer-events: all;
    background-color: #000;
    padding: 20px 120px 10px 50px;
    overflow-y: hidden;
  }
  &-header {
    height: 171px;
    background-color: #15244d;
    display: flex;
    margin-bottom: 10px;
    transition: all linear 0.3s;
    &-right {
      width: 40%;
    }
    &-left {
      width: 60%;
      padding: 20px 0 24px;
    }
  }
  &-btn {
    text-align: center;
  }
  &-body {
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    transition: all linear 0.3s;
    &-left,
    &-right {
      width: 50%;
      height: 100%;
      position: relative;
      padding-top: 500px;
    }
    &-detail {
      height: 1700px;
    }
  }
  &-right-detail {
    height: 850px;
  }
  &-bottom {
    height: 1000px;
  }
  &-close {
    position: absolute;
    top: 20px;
    right: 150px;
    width: 130px;
    height: 40px;
    background-image: url("./img/close.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    pointer-events: all;
    // background: linear-gradient(
    //   302deg,
    //   rgba(108, 151, 255, 0.37) 0%,
    //   rgba(108, 151, 255, 0.37) 0%,
    //   rgba(147, 117, 243, 0.19) 50%,
    //   rgba(58, 115, 255, 0.31) 99%,
    //   #0049fa 99%,
    //   #0049fa 99%
    // );
    // box-shadow: 2px 2px 12px 0px rgba(74, 144, 226, 0.33),
    //   inset 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
    font-size: 30px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    color: #add1ff;
  }
  &-close:hover {
    background-image: url("./img/close_active.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  &-map-left,
  &-map-right {
    position: absolute;
    width: 1920px;
    height: 540px;
    top: -132px;
    background-image: url("./img/shedBg1.png");
    background-size: 100% 100%;
    pointer-events: none;
    transform: scale(1.4);
  }
  &-map-right {
    right: -167px;
  }
  &-map-left {
    left: -186px;
  }
}
</style>
<style lang="scss" scoped>
.illus-bar {
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.ui-choose {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.ui-choose > li {
  @include bg-box(196px, 93px, "iconli.png");
  opacity: 0.5;
  padding-right: 90px;
  text-align: center;
  position: relative;
  color: #fff;
  font-weight: 600;
  zoom: 1;
  margin-right: 76px;
  line-height: 140px;
}
.imgIcon {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100px;
  height: 100px;
}
.ui-icon {
  //width: 65px;
  margin: 0 auto;
  margin-top: 10px;
}
ul.ui-choose > li.selected > .ui-icon {
  opacity: 1 !important;
}
.ui-choose > li .area {
  font-size: 28px;
  vertical-align: top;
  display: inline-block;
  margin-top: 50px;
  position: relative;
  line-height: 1;
}
.ui-choose > li.selected {
  opacity: 1;
}
.ui-choose > li .unit {
  font-size: 18px;
  color: #fff;
  display: block;
  position: absolute;
  bottom: 0px;
  width: 100px;
  right: 0;
  height: 100%;
  line-height: 145px;
  box-sizing: border-box;
  padding-left: 25px;
}
.ui-choose > li .number {
  font-size: 40px;
  color: rgb(255, 168, 107);
  display: block;
  position: absolute;
  top: 0px;
  width: 92px;
  text-align: center;
  line-height: 70px;
  padding-left: 20px;
  right: 0;
  height: 100%;
  box-sizing: border-box;
}
.number {
  font-family: "number";
}
.title {
  font-size: 20px;
  margin-left: 74px;
  margin-bottom: 27px;
  > img {
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
}
.content {
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  font-size: 18px;
  padding-left: 100px;
  &-item {
    width: 25%;
    height: 30px;
    display: flex;
    margin-bottom: 10px;
  }
  .value {
    width: 80%;
    border-bottom: 1px dashed #4b4b4b;
    color: #f4c48f;
    margin-left: 15px;
  }
  .label {
    width: 20%;
    text-align: right;
  }
}
.scaleItem {
  position: absolute;
  transform: scale(0.5);
  top: 0;
  left: 0;
  pointer-events: all;
}
.realTime {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #51eeff;
  text-align: center;
  font-size: 25px;
}
.toolTip {
  position: absolute;
  width: 600px;
  height: 300px;
  z-index: 9999999;
  top: 0;
  left: 0;
  display: none;
  background-color: #000;
  border: 1px solid #e79d26;
  border-radius: 10px;
  &-header {
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #51eeff;
    font-size: 25px;
    border-bottom: 1px solid #ccc;
  }
  &-body {
    height: calc(100% - 50px);
    display: flex;
    flex-direction: column;
  }
  &-item {
    flex: 1;
    display: flex;
    font-size: 30px;
    line-height: 80px;
    > span:nth-child(1) {
      width: 20%;
      text-align: right;
      margin-right: 30px;
      color: #ffefde;
    }
    > span:nth-child(2) {
      width: 80%;
      text-align: left;
      color: #bcebff;
    }
  }
}
:deep(.el-button) {
  position: relative;
  background: linear-gradient(
    302deg,
    rgba(108, 151, 255, 0.37) 0%,
    rgba(108, 151, 255, 0.37) 0%,
    rgba(147, 117, 243, 0.19) 50%,
    rgba(58, 115, 255, 0.31) 99%,
    #0049fa 99%,
    #0049fa 99%
  );
  box-shadow: 2px 2px 12px 0px rgba(74, 144, 226, 0.33),
    inset 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  font-size: 25px;
  z-index: 999999;
}
.transUp {
  transform: translateY(-300px);
}
.transDown {
  transform: translateY(0);
}
.transBodyUp {
  transform: translateY(-55px);
}
.transBodyDown {
  transform: translate(0);
}
.blockHeight {
  height: calc(100% - 171px);
}
.noneHeight {
  height: 100%;
}
</style>